import type { PropsWithChildren } from 'react';
import { ChevronRight } from 'lucide-react';
import { Button } from './ui/button';
import { cn } from '../utils';

type Props = React.ComponentProps<'button'> & {
  icon: React.ElementType | React.ReactNode;
  onClick: () => void;
  loading?: boolean;
  className?: string;
};

const ChevronButton = ({
  icon: IconComponent,
  onClick,
  loading,
  className,
  children,
  ...props
}: PropsWithChildren<Props>) => {
  const icon =
    typeof IconComponent === 'function' ? (
      <IconComponent className="size-8 text-foreground" />
    ) : (
      IconComponent
    );

  return (
    <Button
      loading={loading}
      onClick={onClick}
      variant="ghost"
      className={cn(
        'w-full p-[2.5rem] bg-secondary-bg hover:bg-tertiary/40 rounded-3xl flex items-center justify-between text-left medium4',
        className
      )}
      {...props}>
      <div className="flex items-center gap-[1.6rem]">
        {icon}
        {children}
      </div>
      <ChevronRight className="size-8 text-tertiary" />
    </Button>
  );
};

export { ChevronButton };
